


































import { Vue, Component, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "./types/custom.t";
import CustomContainer from "./CustomContainer.vue";
import CustomText from "./CustomText.vue";


@Component({
  components: {
    CustomContainer,
    CustomText
  },
})
export default class TilesSelect extends Vue {
  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  itemCustomClass?: ICustomStylingClass[];

  @Prop({ default: 0 })
  itemSelected!: number | string;

  @Prop({ default: true })
  showHeadingLabel!: boolean;

  @Prop()
  buyPanelIsLoading?: boolean;

  @Prop()
  headingLabel?: string;

  @Prop()
  tileList!: string[];

  @Prop()
  tileKeyList!: string[];

  get translations() {
    return this.$store.state.translations?.data;
  }

  clickEvent(value: string | number) {
    this.$emit('on-click-item', value, 0)
  }
}
